import axios from "axios";

export async function get(){
    const resp = await axios.get('https://icanhazip.com/');
    let ip = resp.data;    
    return ip

}